import {
	SET_EVENTS,
	SET_EVENT,
	CLEAR_EVENTS,
	CLEAR_EVENT,
	ADD_EVENT,
	UPDATE_EVENT,
	REMOVE_EVENT,
} from './actionTypes';

export const event = (state = {}, action) => {
	switch (action.type) {
		case SET_EVENT:
			return action.payload;
		case UPDATE_EVENT:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_EVENT:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_EVENTS:
			return action.payload;
		case ADD_EVENT:
			return [...state, action.payload];
		case UPDATE_EVENT:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_EVENT:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_EVENTS:
			return [];
		default:
			return state;
	}
};
